<syslink-select
    label="Day"
    name="Day"
    displayKey="Value"
    [items]="days"
    [model]="days[model-1]"
    (modelChange)="modelChange.emit($event?.Id)"
></syslink-select>
